import { Component, OnInit } from '@angular/core';
import { DomSanitizer, SafeHtml } from '@angular/platform-browser';
import { ActivatedRoute } from '@angular/router';
import { RenaultLocalCampaignOrderDataViewContentDTO } from '../../../models/renault-local-campaign-order-data-dto';
import { TrackingService } from '../../../services/tracking.service';

@Component({  
  templateUrl: './local-campaign-viewer.component.html',
  styleUrls: ['./local-campaign-viewer.component.scss']
})
export class LocalCampaignViewerComponent implements OnInit {

  idOrderData: string;
  model: RenaultLocalCampaignOrderDataViewContentDTO;
  htmlPrint: SafeHtml;

  constructor(private route: ActivatedRoute,
    private service: TrackingService,
    private sanitizer: DomSanitizer) { }

  ngOnInit(): void {
    this.idOrderData = this.route.snapshot.paramMap.get('id');

    if (this.idOrderData !== null) {
      this.service.viewLocalCampaign(this.idOrderData).subscribe(resp => {
        this.model = resp;
        this.htmlPrint = this.sanitizer.bypassSecurityTrustHtml(this.model.ContentHtml);
      });
    }

  }

}
